<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Endereço Residencial</h1>
    </div>
    <div class="row justify-content-center">
     <div class="col-12 col-md-10">
       <form @submit="onSubmit">
          <div class="form-row">
            <div class="form-group col-12 col-md-12 text-left">
              <label for="cep">CEP</label>
              <input type="text" class="form-control form-control-lg" pattern="\d{5}-?\d{3}" v-model="cep" v-mask="'zipcode'" placeholder="CEP" @change="aoMudarCep" v-focus required>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12 col-md-9 text-left">
              <label for="logradouro">Endereço</label>
              <input type="text" class="form-control form-control-lg" v-model="logradouro" placeholder="Logradouro" required>
            </div>
            <div class="form-group col-12 col-md-3 text-left">
              <label for="Numero">Número</label>
              <input type="text" class="form-control form-control-lg" v-model="numero" pattern="\d+" title="Números apenas" placeholder="Nº" required>
            </div>
            <div class="form-group col-12 col-md-12 text-left">
              <label for="complemento">Complemento</label>
              <input type="text" class="form-control form-control-lg" v-model="complemento" placeholder="Complemento" >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12 col-md-12 text-left">
              <label for="bairro">Bairro</label>
              <input type="text" class="form-control form-control-lg" v-model="bairro" placeholder="Bairro" required/>
            </div>
            <div class="form-group col-12 col-md-12 text-left">
              <label for="estado">Estado</label>
              <at-select ref="ufSelect" v-model="uf" filterable size="large" placeholder="Estado" @on-change="onUfChange" required>
                <at-option v-for="(state, i) in estados" :key="`stateOptions${i}`" :value="state.uf">{{state.nome}}</at-option>
              </at-select>
            </div>
            <div class="form-group col-12 col-md-12 text-left">
              <label for="cidade">Cidade</label>
              <at-select ref="citySelect" v-model="cidade" filterable size="large" placeholder="Cidade" required>
                <at-option v-for="(city, i) in cidades" :key="`cityOptions${i}`"  :value="city.nome">{{city.nome}}</at-option>
              </at-select>
            </div>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary" type="submit" v-focus>Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
     </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'
import vSelect from "vue-select"
import HubConsultaClient from '../../utils/hub-consulta-client'
import StringHelper from '@/utils/string-helper'

export default {
  components: {
    vSelect
  },
  data() {
    const endereco = this.currentUser.Pessoal.Endereco
    return {
      cep: endereco ? endereco.Cep : null,
      logradouro: endereco ? endereco.Logradouro : null,
      numero: endereco ? endereco.Numero: null,
      complemento: endereco ? endereco.Complemento: null,
      bairro: endereco ? endereco.Bairro: null,
      uf: endereco ? endereco.Uf: null,
      cidade: endereco ? endereco.Cidade: null,
      estados: [],
      cidades: [],
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  computed: {
    estaCidadeDesabilitado: function() { return this.cidades.length == 0 },
  },
  methods: {
    aoMudarCep(e) {
      if(Masker.unmaskZipcode(e.target.value).length < 8) return
      this.estaBuscandoEndereco = true
      HubConsultaClient.pegarCeps(e.target.value)
        .then(endereco => {
          this.logradouro = endereco.logradouro
          this.bairro = endereco.bairro
          this.uf = endereco.uf
          this.cidade = endereco.localidade
        })
        .catch(() => {
          
        })
    },
    onUfChange() {
      this.cidades = []
      if(!this.uf) {
        this.cidade = ''
        return
      }
      HubConsultaClient.pegarCidades(this.uf)
        .then(cidades => {
          this.cidades = cidades
          this.$refs.citySelect.$el.children[0].children[2].required = true;
          
          if(this.cidade) {
            this.setCity()
          }
        })
    },
    setCity() {
      const city = this.cidades.find(city => {
        return StringHelper.removeAccents(city.nome.toUpperCase()) == StringHelper.removeAccents(this.cidade.toUpperCase())
      })
      if(!city) {
        this.cidade = ''
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = ''
        setTimeout(() => this.cidade = city.nome, 100)
      }
    },
    onSubmit(e) {
      e.preventDefault()
      
      this.currentUser.Pessoal.Endereco.Cep = this.cep
      this.currentUser.Pessoal.Endereco.Logradouro = this.logradouro
      this.currentUser.Pessoal.Endereco.Numero = this.numero
      this.currentUser.Pessoal.Endereco.Complemento = this.complemento
      this.currentUser.Pessoal.Endereco.Bairro = this.bairro
      this.currentUser.Pessoal.Endereco.Uf = this.uf
      this.currentUser.Pessoal.Endereco.Cidade = this.cidade

      this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})
    }
  },
  created() {
    HubConsultaClient.pegarCeps(this.cep)
      .then(endereco => {
         this.logradouro = endereco.logradouro
         this.bairro = endereco.bairro
         this.uf = endereco.uf
         this.cidade = endereco.localidade
      })
      .catch(() => {
        
      })

    HubConsultaClient.pegarEstados()
      .then(estados => {
        this.estados = estados
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        const uf = this.uf
        const city = this.cidade
        this.uf = ''
        this.$refs.ufSelect.$el.children[0].children[2].required = true;
        
        setTimeout(() => {
          this.uf = uf
          this.cidade = city
        }, 100)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/AddressConfirmationStep.vue